import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../paths';
import { DashboardActionTile, DealerOnly } from '../common';

interface RentalWidgetProps {
  onCreateNew?: () => void;
}

const RentalWidget = ({ onCreateNew }: RentalWidgetProps) => (
  <DashboardActionTile
    tone="dark"
    title="Půjčení vozu"
    description="Zapůjčit vůz zákazníkovi"
    icon={<DirectionsCarFilledOutlinedIcon fontSize="large" />}
    onClick={onCreateNew}
  />
);

const RentalWidgetConnectedContent = () => {
  const navigate = useNavigate();

  return <RentalWidget onCreateNew={() => navigate(PATHS.CAR_RENTAL())} />;
};

export const RentalWidgetConnected = () => (
  <DealerOnly>
    <RentalWidgetConnectedContent />
  </DealerOnly>
);
